/* unplugin-vue-components disabled */import { render } from "./agreement.vue?vue&type=template&id=4a2c5255&scoped=true"
import script from "./agreement.vue?vue&type=script&lang=js"
export * from "./agreement.vue?vue&type=script&lang=js"

import "./agreement.vue?vue&type=style&index=0&id=4a2c5255&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2c5255"]])

export default __exports__